module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcp-category"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticClass: "contentLoader"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "cat-view"
  }, [_c('div', {
    staticClass: "cat-bg",
    style: ('background-image: url(' + _vm.cat.image + ');')
  }, [_c('div', {
    staticClass: "cat"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.cat.name,
      "subTitle": _vm.cat.desc,
      "titleClass": "largeTitle"
    }
  }), _vm._v(" "), _c('mu-list', _vm._l((_vm.posts), function(post, index) {
    return _c('mu-list-item', {
      key: ("post-" + index),
      staticClass: "item",
      attrs: {
        "title": post.post_title
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goTo(post.post_slug)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "leftAvatar"
      },
      slot: "leftAvatar"
    }, [_c('mu-avatar', {
      attrs: {
        "src": post.post_video_thumb
      }
    })], 1), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(post.post_video_desc))
      },
      slot: "describe"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "right"
      },
      slot: "right"
    }, [_c('mu-icon', {
      attrs: {
        "value": "play_circle_filled",
        "color": "#0179d5"
      }
    })], 1), _vm._v(" "), _c('mu-divider')], 1)
  }), 1)], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.cat.name)
    }
  })
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc",
    domProps: {
      "textContent": _vm._s(_vm.cat.desc)
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-389ea4dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HealthCareProfessional/Category/Category.vue
// module id = 3677
// module chunks = 1